
import React from 'react';
import { MetaArticle } from './page_data'; 

export type ArticleListProps = {
  title: string,
  listItems: Array<MetaArticle>,
  btnClickHandler: (articleId: string) => void,
}

const ArticleList: React.FunctionComponent<ArticleListProps> = ({
  title,
  listItems,
  btnClickHandler,
}) => (
  <aside className="article-list p-4">
    <div className="article-list__heading">
      {/\w/.test(title) ? title : 'Topics'}
    </div>
    <div
      className="list-group list-group-flush article-list__body pl-4"
    >
      { listItems.length
        ? listItems.map( articleListItem => {
          const {title, id, href} = articleListItem;
          const listItemClassName = (
            'list-group-item list-group-item-action article-list__item' +
            ( articleListItem.selected ? 'selected' : '')
          );
     
          return (
            <a
              href={href}
              onClick={(e)=>btnClickHandler(id)}
              key={id}
              data-article-id={id}
              className={listItemClassName}
            >
              {title}
            </a>
          );
        })
        : <div className="empty-search">
            No Topics Match Your Search Conditions'
          </div>
      }
    </div>
  </aside>
)
export default ArticleList;